import { EntityDragEvent } from './../../ng3/controls/mouse/mouse-entity.service';
import { Ng3MosueWheelEvent } from './../../ng3/controls/mouse/mouse-canvas.service';
import { SceneService } from './../../ng3/components/scene.service';
import {
  BoundingBox2,
  BoundingBox2FromCenterSize,
} from './../../ng3/share/boundingbox2';
import { initialImageTest2State } from '../../image-store/image-store.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { Vector2, Vector3 } from 'three';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';

import { ImageState } from '../share/model';
import { applyColormap } from '../share/colormap';
import { RGBImage2 } from '../share/image';

export interface ShowImageIntensity {
  pos: Vector3;
  index: Vector3;
  intensity: number;
}

export interface Display2DProperty {
  image: RGBImage2;
  rotation: Vector3;
}
@Component({
  selector: 'app-image3d',
  templateUrl: './image3d.component.html',
  styleUrls: ['./image3d.component.css'],
})
export class Image3dComponent {
  // image$: Observable<RGBImage2>;
  image$: Observable<Display2DProperty>;
  private boxSubject = new BehaviorSubject<BoundingBox2>(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(1, 1)),
  );
  box$ = this.boxSubject.asObservable();
  @Input()
  get box(): BoundingBox2 {
    return this.boxSubject.value;
  }
  set box(b: BoundingBox2) {
    this.boxSubject.next(b);
  }
  @Input() resize: 'image' | 'canvas' | 'fix' = 'canvas';
  @Input() pos: Vector3 = new Vector3(0, 0, 0);
  @Output() scroll = new EventEmitter<Ng3MosueWheelEvent>();

  @Output() drag = new EventEmitter<EntityDragEvent>();
  private stateSubject = new BehaviorSubject<ImageState>(
    initialImageTest2State(),
  );
  state$ = this.stateSubject.asObservable();
  @Input()
  get image(): ImageState {
    return this.stateSubject.value;
  }
  set image(s: ImageState) {
    this.stateSubject.next(s);
  }
  @Input() z = 0;

  constructor(private sceneService: SceneService) {
    this.image$ = combineLatest(this.state$, this.box$).pipe(
      map((x) => this.getDisplay2DProperty(x[0], x[1])),
    );
  }

  onScroll(e: Ng3MosueWheelEvent) {
    this.scroll.emit(e);
  }

  onDrag(d: EntityDragEvent) {
    this.drag.emit(d);
  }

  getDisplay2DProperty(state: ImageState, box: BoundingBox2) {
    const imageSlice = state.filter.filter(state.slicer.slice(state.image));
    const image2 = applyColormap(imageSlice, state.colormap);
    const imageBox = this.imageBox(image2, box);
    const result = {
      image: new RGBImage2(
        imageBox.center,
        imageBox.size,
        image2.meta.shape,
        image2.r,
        image2.g,
        image2.b,
      ),
      rotation: state.rotation,
    };

    return result;
  }
  getImage(state: ImageState, box: BoundingBox2) {
    // state.slicer = this.updateSlicer(state, box, cross);
    // this.getImageInfo(state, box, cross);
    const imageSlice = state.filter.filter(state.slicer.slice(state.image));
    const image2 = applyColormap(imageSlice, state.colormap);
    const imageBox = this.imageBox(image2, box);
    return new RGBImage2(
      imageBox.center,
      imageBox.size,
      image2.meta.shape,
      image2.r,
      image2.g,
      image2.b,
    );
  }

  private imageBox(image: RGBImage2, box: BoundingBox2): BoundingBox2 {
    switch (this.resize) {
      case 'image':
        return new BoundingBox2FromCenterSize(
          image.meta.center,
          image.meta.size,
        );
      case 'fix':
        return box;
      case 'canvas':
        const sceneSize = this.sceneService.size;
        const ratio = Math.min(
          sceneSize.size.x / image.meta.size.x,
          sceneSize.size.y / image.meta.size.y,
        );
        return new BoundingBox2FromCenterSize(
          new Vector2(0, 0),
          new Vector2(image.meta.size.x * ratio, image.meta.size.y * ratio),
        );
    }
  }
}
